<script>
    import { flip } from "svelte/animate";
    import { fly } from "svelte/transition";
    import { notifications } from "../../stores/notifications";
    import { onMount } from "svelte";
  
    let alertOpen = true;
  
    function closeAlert(notificationId) {
      // Burada notificationId ile ilgili bildirimi kapatmalısınız
      // notifications store'unu güncellemeniz gerekebilir.
      // Örneğin: notifications.update(n => n.filter(item => item.id !== notificationId));
      alertOpen = false;
    }
  
  </script>
  
  <div class="notifications" 
  style="position: fixed;
      top: 1px;
      right: 0;
      margin: 0 auto;
      padding: 0;
      z-index: 1000;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      pointer-events: none;">
    {#each $notifications as notification (notification.id)}
      <div class="toast" animate:flip transition:fly={{ y: 30 }}  
      style=" flex: 0 0 auto;
      margin-bottom: 1px;" >
        <div class="content" 
        style=" padding: 1px;
      display: block;
      color: white;
      font-weight: 500;">
          <div class="grid place-content-end h-48">
            {#if alertOpen}
              <div class={`text-white px-6 py-4 border-0 rounded relative mb-4 bg-${notification.type}-500`}>
                <span class="text-xl inline-block mr-5 align-middle">
                  <i class="fas fa-bell"></i>
                </span>
                <span class="inline-block align-middle mr-8">
                  <b class="capitalize">{#if notification.icon}<i class={notification.icon} />{/if}</b> {notification.message}
                </span>
                <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none" on:click={() => closeAlert(notification.id)}>
                  <span>×</span>
                </button>
              </div>
            {/if}
          </div>
        </div>
      </div>
    {/each}
  </div>
  

  